import { useState, type FormEvent } from 'react';
import { api, ApiError } from '../lib/api.js';
import { useI18n } from '../i18n.js';
import { Field, Notice } from '../components/ui.js';

export function LoginPage({ onSuccess }: { onSuccess: () => void }) {
  const { t, toggle } = useI18n();
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.login(password);
      onSuccess();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="card login-card" onSubmit={submit}>
        <div className="row between" style={{ marginBottom: 14 }}>
          <div className="brand">
            MSC<span>{t('appName')}</span>
          </div>
          <button type="button" className="btn small" onClick={toggle}>
            {t('language')}
          </button>
        </div>
        {error && <Notice kind="bad">{error}</Notice>}
        <Field label={t('password')}>
          <input
            type="password"
            value={password}
            autoFocus
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </Field>
        <button type="submit" className="btn primary" style={{ width: '100%', marginTop: 14 }} disabled={busy}>
          {busy ? t('loading') : t('login')}
        </button>
      </form>
    </div>
  );
}
